import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DashboardService } from '../dashboard.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  updateProfileResquestObject: any = {};
  getProfileResponseObject: any;
  editName: any;
  editMobile: any;
  editEmail: any;
  role: string;
  isEditing = true;
  roleName: string;
  personName: any;
  Mobile: any;
  Email: any;
  date_of_Birth: any;
  company_name: any;
  company_email: any;
  address: any;
  editAddress: any;
  editDateOfBirth: any;

  constructor(private dashboardService: DashboardService, private router: Router, private toastr: ToastrService) {

    this.role = localStorage.role;
    if (this.role == '1') {
      this.roleName = 'admin';
    } else if (this.role == '2') {
      this.roleName = 'epc';
    }
    else if (this.role == '3') {
      this.roleName = 'wms';
    }
    else if (this.role == '4') {
      this.roleName = 'normal';
    }
    else if (this.role == '6') {
      this.roleName = 'ze';
    }
    else if (this.role == '7') {
      this.roleName = 'dg';
    }

  }

  ngOnInit() {
    if (this.role == '1') {
      this.getAdminProfile();
    } else if (this.role == '2') {
      this.getEpcProfile();
    } else if (this.role == '3') {
      this.getWmsProfile();
    } else if (this.role == '4') {
      this.getNormalProfile();
    }
    else if (this.role == '6') {
      this.getZeProfile();
    }
    else if (this.role == '7') {
      this.getZeProfile();
    }
  }

  onUpdate(formData) {

    //   this.updateProfileResquestObject = {
    //     name: formData.value.userName,
    //     email: formData.value.email,
    //     mobile_no: formData.value.mobile_no
    //   };

    //   this.updateAdminProfileAPICall(this.updateProfileResquestObject);

    if (this.role == '1') {
      this.updateProfileResquestObject = {
        name: formData.value.userName,
        email: formData.value.email,
        mobile_no: formData.value.mobile_no,
      };
    } else if (this.role == '2') {
      this.updateProfileResquestObject = {
        name: formData.value.userName,
        email: formData.value.email,
        mobile_no: formData.value.mobile_no
      };
    }

    if (this.role == '1') {
      this.updateAdminProfileAPICall(this.updateProfileResquestObject);
    } else if (this.role == '2') {
      this.updateEpcProfileAPICall(this.updateProfileResquestObject);
    }

  }

   // Admin Update Profile
   updateAdminProfileAPICall(updateProfileResquestObject) {
    this.dashboardService
      .updateAdminProfileAPICall(updateProfileResquestObject).subscribe(
        async data => {
            if (data.status) {
            this.toastr.info(data.message);
            this.router.navigate(['inject-solar/dashboard']);
          }
        },
        err => {
          return console.error(err);
        }
      );
  }

   // Get Admin Profile
   getAdminProfile() {

    this.dashboardService
      .getAdminProfile().subscribe(
        async data => {
          if (data.status) {
            this.getProfileResponseObject = data.resultObject;
            this.editName = data.resultObject.name;
            this.editMobile = data.resultObject.mobile_no;
            this.editEmail = data.resultObject.email;
            this.editAddress = data.resultObject.address;
          } else if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(['/login']);
          }
        },
        err => {
          return console.error(err);
        }
      );
   }

    // Epc Update Profile
    updateEpcProfileAPICall(updateProfileResquestObject) {

      this.dashboardService
        .updateEpcProfileAPICall(updateProfileResquestObject).subscribe(
          async data => {
            if (data.status) {
              this.toastr.success(data.message);
              this.router.navigate(['inject-solar/dashboard']);
            }
          },
          err => {
            return console.error(err);
          }
        );
    }

  // get EPC profile
  getEpcProfile() {
      this.dashboardService
      .getEpcProfile().subscribe(
        async data => {

          if (data.status) {
            this.personName = data.resultObject.name;
            this.address = data.resultObject.address;
            this.Mobile = data.resultObject.mobile_no;
            this.Email = data.resultObject.email;
            this.company_name = data.resultObject.company_name;
            this.company_email = data.resultObject.company_email;

          } else if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(['/login']);
          }
        },
        err => {
          return console.error(err);
        }
      );
   }

 // get WMS profile
   getWmsProfile(){
    this.dashboardService
      .getWmsProfile().subscribe(
        async data => {
          if (data.status) {
            this.personName = data.resultObject[0].name;
            this.address = data.resultObject[0].address;
            this.Mobile = data.resultObject[0].mobile_no;
            this.Email = data.resultObject[0].email;
            } else if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(['/login']);
          }
        },
        err => {
          return console.error(err);
        }
      );
   }

   //get Normal profile
   getNormalProfile(){
    this.dashboardService
      .getNormalProfile().subscribe(
        async data => {
          if (data.status) {
            this.personName = data.resultObject[0].name;
            this.address = data.resultObject[0].address;
            this.Mobile = data.resultObject[0].mobile_no;
            this.Email = data.resultObject[0].email;
            } else if (data.message == 'Unauthorised or Login Time-out') {
            this.toastr.info(data.message);
            this.router.navigate(['/login']);
          }
        },
        err => {
          return console.error(err);
        }
      );
   }
   //get ze profile
   getZeProfile(){
    this.dashboardService
    .getZeProfile().subscribe(
      async data => {
        if (data.status) {
          this.personName = data.resultObject[0].name;
          this.address = data.resultObject[0].address;
          this.Mobile = data.resultObject[0].mobile_no;
          this.Email = data.resultObject[0].email;
          } else if (data.message == 'Unauthorised or Login Time-out') {
          this.toastr.info(data.message);
          this.router.navigate(['/login']);
        }
      },
      err => {
        return console.error(err);
      }
    );
   }
}
